
import request from "@/http/request"
//获取问题
export const getQuestions = (params) => {
    return request.post('/api/market/questionOption/list', params)
}
export const submitQuestions = (params) => {
    return request.post('/api/market/questionOption/submit', params)
}
export const getAllCities = () => {
    let params = {
        head: {
            // deviceId: sessionStorage.getItem("deviceId"),
        },
        body: {
        },
    };
    return request.post('/api/market/city/code/list', params)
}
